<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-toolbar class="md-success">
        <div class="md-toolbar-row">
          <div class="md-toolbar-section-start">
            <hierarchy-menu></hierarchy-menu>
          </div>
        </div>
      </md-toolbar>
      <br />
    </div>

    <div class="md-layout-item" v-if="!getStatus()">
      <!-- <h4 class="info-text">Upload Successful</h4> -->
      <md-empty-state
        md-icon="power_settings_new"
        md-label="Device is Offline"
        md-description="Dashboard will be shown when device will be Online"
      ></md-empty-state>
    </div>

    <div v-if="getStatus()" class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">{{$lang.titles.load_values}}</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="loadValues" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="L1" md-numeric>
                {{numberFormat(item.L1)}}
              </md-table-cell>
              <md-table-cell md-label="L2" md-numeric>
                {{numberFormat(item.L2)}}
              </md-table-cell>
              <md-table-cell md-label="L3" md-numeric>
                {{numberFormat(item.L3)}}
              </md-table-cell>
              <md-table-cell md-label="" md-numeric>{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <div v-if="getStatus()" class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">{{$lang.titles.more_values}}</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="moreValues" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="L1" md-numeric>
                {{numberFormat(item.L1)}}
              </md-table-cell>
              <md-table-cell md-label="L2" md-numeric>
                {{numberFormat(item.L2)}}
              </md-table-cell>
              <md-table-cell md-label="L3" md-numeric>
                {{numberFormat(item.L3)}}
              </md-table-cell>
              <md-table-cell md-label="" md-numeric>{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <div v-if="getStatus()" class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">{{$lang.titles.energy_values}}</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="energyDataTable" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="L1" md-numeric>
                {{numberFormat(item.L1)}}
              </md-table-cell>
              <md-table-cell md-label="L2" md-numeric>
                {{numberFormat(item.L2)}}
              </md-table-cell>
              <md-table-cell md-label="L3" md-numeric>
                {{numberFormat(item.L3)}}
              </md-table-cell>
              <md-table-cell md-label="SUM" md-numeric>
                {{numberFormat(item.SUM)}}
              </md-table-cell>
              <md-table-cell md-label="" md-numeric>{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import snackBar from "@/components/SnackBar";
import hierarchyMenu from "@/components/HierarchyMenu";
import { SlideYDownTransition } from "vue2-transitions";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import AnimatedNumber from "animated-number-vue";

export default {
  components: {
    "hierarchy-menu": hierarchyMenu,
    "snack-bar": snackBar,
    SlideYDownTransition,
    AnimatedNumber
  },

  data() {
    return {
      status: {
        running: false,
        buttonText: ""
      },

      loadValues: [
        {
          id: 1,
          value: this.$lang.dashboard.voltage,
          unit: "V",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 2,
          value: this.$lang.dashboard.current,
          unit: "A",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 3,
          value: this.$lang.dashboard.voltage_angle,
          unit: "°",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 4,
          value: this.$lang.dashboard.current_angle,
          unit: "°",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 5,
          value: this.$lang.dashboard.power_factor,
          unit: "",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 6,
          value: this.$lang.dashboard.active_power,
          unit: "W",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 7,
          value: this.$lang.dashboard.reactive_power,
          unit: "var",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 8,
          value: this.$lang.dashboard.apparent_power,
          unit: "VA",
          L1: "-",
          L2: "-",
          L3: "-"
        }
      ],
      moreValues: [
        {
          id: 1,
          value: this.$lang.dashboard.voltage_distortion,
          unit: "%",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 2,
          value: this.$lang.dashboard.current_distortion,
          unit: "%",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 3,
          value: this.$lang.dashboard.phase_to_phase_voltage,
          unit: "V",
          L1: "-",
          L2: "-",
          L3: "-"
        },
        {
          id: 4,
          value: this.$lang.dashboard.phase_to_phase_voltage_angle,
          unit: "°",
          L1: "-",
          L2: "-",
          L3: "-"
        }
      ],
      energyDataTable: [
        {
          id: 1,
          value: this.$lang.dashboard.active_energy,
          unit: "kWh",
          L1: "-",
          L2: "-",
          L3: "-",
          SUM: "-"
        },
        {
          id: 2,
          value: this.$lang.dashboard.reactive_energy,
          unit: "kvarh",
          L1: "-",
          L2: "-",
          L3: "-",
          SUM: "-"
        },
        {
          id: 3,
          value: this.$lang.dashboard.apparent_energy,
          unit: "kVAh",
          L1: "-",
          L2: "-",
          L3: "-",
          SUM: "-"
        }
      ]
    };
  },

  computed: {
    WSmessage() {
      return this.$store.getters.getDataMessage;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    }
  },

  watch: {
    WSmessage: function(payload, oldPayload) {
      if (payload.U) {
        this.loadValues[0].L1 = payload.U.L1;
        this.loadValues[0].L2 = payload.U.L2;
        this.loadValues[0].L3 = payload.U.L3;
      }

      if (payload.I) {
        this.loadValues[1].L1 = payload.I.L1;
        this.loadValues[1].L2 = payload.I.L2;
        this.loadValues[1].L3 = payload.I.L3;
      }

      if (payload.F_U) {
        this.loadValues[2].L1 = payload.F_U.L1;
        this.loadValues[2].L2 = payload.F_U.L2;
        this.loadValues[2].L3 = payload.F_U.L3;
      }

      if (payload.F_I) {
        this.loadValues[3].L1 = payload.F_I.L1;
        this.loadValues[3].L2 = payload.F_I.L2;
        this.loadValues[3].L3 = payload.F_I.L3;
      }

      if (payload.PF) {
        this.loadValues[4].L1 = payload.PF.L1;
        this.loadValues[4].L2 = payload.PF.L2;
        this.loadValues[4].L3 = payload.PF.L3;
      }

      if (payload.P) {
        this.loadValues[5].L1 = payload.P.L1;
        this.loadValues[5].L2 = payload.P.L2;
        this.loadValues[5].L3 = payload.P.L3;
      }

      if (payload.Q) {
        this.loadValues[6].L1 = payload.Q.L1;
        this.loadValues[6].L2 = payload.Q.L2;
        this.loadValues[6].L3 = payload.Q.L3;
      }

      if (payload.S) {
        this.loadValues[7].L1 = payload.S.L1;
        this.loadValues[7].L2 = payload.S.L2;
        this.loadValues[7].L3 = payload.S.L3;
      }

      if (payload.DF_U) {
        this.moreValues[0].L1 = payload.DF_U.L1;
        this.moreValues[0].L2 = payload.DF_U.L2;
        this.moreValues[0].L3 = payload.DF_U.L3;
      }

      if (payload.DF_I) {
        this.moreValues[1].L1 = payload.DF_I.L1;
        this.moreValues[1].L2 = payload.DF_I.L2;
        this.moreValues[1].L3 = payload.DF_I.L3;
      }

      if (payload.U_PP) {
        this.moreValues[2].L1 = payload.U_PP.L1;
        this.moreValues[2].L2 = payload.U_PP.L2;
        this.moreValues[2].L3 = payload.U_PP.L3;
      }

      if (payload.F_UPP) {
        this.moreValues[3].L1 = payload.F_UPP.L1;
        this.moreValues[3].L2 = payload.F_UPP.L2;
        this.moreValues[3].L3 = payload.F_UPP.L3;
      }

      if (payload.E_I) {
        this.energyDataTable[0].L1 = payload.E_I.L1 / 1000.0;
        this.energyDataTable[0].L2 = payload.E_I.L2 / 1000.0;
        this.energyDataTable[0].L3 = payload.E_I.L3 / 1000.0;
        this.energyDataTable[0].SUM =
         this.energyDataTable[0].L1 + this.energyDataTable[0].L2 + this.energyDataTable[0].L3;
      }

      if (payload.Q_E) {
        this.energyDataTable[1].L1 = payload.Q_E.L1 / 1000.0;
        this.energyDataTable[1].L2 = payload.Q_E.L2 / 1000.0;
        this.energyDataTable[1].L3 = payload.Q_E.L3 / 1000.0;
        this.energyDataTable[1].SUM =
          this.energyDataTable[1].L1 + this.energyDataTable[1].L2 + this.energyDataTable[1].L3;
      }

      if (payload.S_E) {
        this.energyDataTable[2].L1 = payload.S_E.L1 / 1000.0;
        this.energyDataTable[2].L2 = payload.S_E.L2 / 1000.0;
        this.energyDataTable[2].L3 = payload.S_E.L3 / 1000.0;
        this.energyDataTable[2].SUM =
          this.energyDataTable[2].L1 + this.energyDataTable[2].L2 + this.energyDataTable[2].L3;
      }
    }
  },

  methods: {
    numberFormat(value) {
      return `${Number(value).toFixed(3)}`;
    },

    getStatus() {
      try {
        if (
          this.deviceList[
            this.deviceList.findIndex(e => e.mac == this.selectedDevice.mac)
          ].status == "ONLINE"
        ) {
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    getDeviceType() {
      try {
        return this.deviceList[
          this.deviceList.findIndex(e => e.mac == this.selectedDevice.mac)
        ].device;
      } catch (err) {
        return "PTE";
      }
    }

  }
};
</script>

<style scoped>
#map {
  margin: 0;
  max-height: 500px;
}

.normal-header {
  padding: 0 !important;
  min-height: 0px;
}

/* .md-button.md-simple i,
.md-button.md-simple:hover i {
  color: #ffffff !important;
} */

.md-toolbar {
  position: inherit;
}

.modal-header {
  opacity: 1;
}

.stats-layout {
  justify-content: center;
  text-align: center;
}

.stats-title {
  margin-top: -20px;
}

.card-title {
  margin: 10px;
}

.modal-footer {
  padding: 0px 0px 5px;
}

.item-change {
  -webkit-text-fill-color: #f44336 !important;
  font-weight: 700;
}
</style>
